<div class="dialog-padding">
  <h3 class="title" id="selectDriver-text-header" mat-dialog-title>
    {{ isWavRide() ? 'Select Provider' : 'Select Driver' }}
  </h3>
  <div mat-dialog-content>
    <h1>
      Ride on {{ data.rideRequest.formattedItineraryDate }} at
      <strong>{{ data.rideRequest.formattedPickupTime }}</strong>
    </h1>
    <ng-container *ngIf="journeyInterestedDrivers">
      <div class="interest-list" *ngIf="journeyInterestedDrivers.length > 0" id="selectDriver-section-interestedDrivers">
        <app-select-driver-list-item
          *ngFor="let journeyInterestedDriver of journeyInterestedDrivers"
          [journeyInterestedDriver]="journeyInterestedDriver"
          [isWavRide]="false"
          [pickupTime]="data.rideRequest.formattedPickupTime"
          (journeyInterestedDriverSelected)="handleJourneyInterestedDriverSelected($event)"
        ></app-select-driver-list-item>
      </div>
    </ng-container>
    <ng-container *ngIf="interestedDrivers">
      <ng-container *ngIf="getRequestedTimes(interestedDrivers) as requestedTimes">
        <div class="interest-list" *ngIf="requestedTimes.length > 0" id="selectDriver-section-interestedDrivers">
          <app-select-driver-list-item
            *ngFor="let interestedDriver of requestedTimes"
            [interestedDriver]="interestedDriver"
            [isWavRide]="isWavRide()"
            [pickupTime]="data.rideRequest.formattedPickupTime"
            (interestedDriverSelected)="handleInterestedDriverSelected($event)"
          ></app-select-driver-list-item>
        </div>
      </ng-container>
      <ng-container *ngIf="getProposedTimes(interestedDrivers) as proposedTimes">
        <div class="interest-list" *ngIf="proposedTimes.length > 0" id="selectDriver-section-proposedTimes">
          <mat-divider></mat-divider>
          <h3 class="dividing-header">Proposed Time</h3>
          <app-select-driver-list-item
            *ngFor="let interestedDriver of proposedTimes"
            [interestedDriver]="interestedDriver"
            [isWavRide]="isWavRide()"
            [pickupTime]="data.rideRequest.formattedPickupTime"
            [timeZone]="data.rideRequest.timeZone"
            (interestedDriverSelected)="handleInterestedDriverSelected($event)"
          ></app-select-driver-list-item>
        </div>
      </ng-container>
      <ng-container *ngIf="getNotOnPlatformInterest(interestedDrivers) as offPlatformTimes">
        <div class="interest-list" *ngIf="offPlatformTimes.length > 0" id="selectDriver-section-offPlatform">
          <mat-divider></mat-divider>
          <h3 class="dividing-header">Off-Platform Providers</h3>
          <app-select-driver-list-item
            *ngFor="let interestedDriver of offPlatformTimes"
            [interestedDriver]="interestedDriver"
            [isWavRide]="isWavRide()"
            [pickupTime]="data.rideRequest.formattedPickupTime"
            (interestedDriverSelected)="handleInterestedDriverSelected($event)"
          ></app-select-driver-list-item>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="providersIgnoringRideRequest">
      <ng-container *ngIf="providersIgnoringRideRequest?.length > 0">
        <mat-divider></mat-divider>
        <h3 class="dividing-header">Provider Ignored</h3>
        <app-select-driver-list-item
          *ngFor="let provider of providersIgnoringRideRequest"
          [interestedDriver]="convertProviderToInterestedDriver(provider)"
          [isIgnoringProvider]="true"
          id="selectDriver-listItem-ignoringProvider-{{ provider.id }}"
        ></app-select-driver-list-item>
      </ng-container>
    </ng-container>
    <div mat-dialog-actions align="end">
      <button id="selectDriver-button-close" type="button" mat-button data-dismiss="modal" (click)="close()">Close</button>
    </div>
  </div>
</div>
